/* eslint-disable jsx-a11y/tabindex-no-positive */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { managerContent_exploreCategory_subCategories } from 'Managers/graphql/__generated__/managerContent';
import useViewportWidth from 'utils/useViewportWidth';
import { Breakpoints } from '@unmind/design-system/theme/deprecated';
import RoutePath from '../../../App/RoutePath';
import GenericExploreContent from '../../../Explore/GenericExploreContent/GenericExploreContent';

import './ManagersCategorySection.scss';

export interface CategorySectionProps {
  category: managerContent_exploreCategory_subCategories;
  assetToken?: string | null;
}

export const ManagersCategorySection = ({
  category,
  assetToken,
}: CategorySectionProps) => {
  const { t: translate } = useTranslation('homepage');
  const width = useViewportWidth();

  // On mobile screens we show 2 items, on desktop 3
  const viewAllLimit = width <= Breakpoints.XS ? 2 : 3;
  const viewAll = (category.content?.length ?? 0) > viewAllLimit;

  return category.content?.length ? (
    <section className="managers-category-section">
      <div className="heading-wrapper">
        <h2 className="title-m">{category.title}</h2>
        <div className="arrow-wrapper">
          {viewAll ? (
            <Link
              className="link action-l"
              to={{
                pathname: `${RoutePath.Explore}/${category.slug}`,
                state: { from: location.pathname },
              }}
              aria-label={translate(
                'your_courses_section.arrow_link_button.text',
              )}
            >
              {translate('your_courses_section.arrow_link_button.text')}
            </Link>
          ) : null}
        </div>
      </div>
      <GenericExploreContent
        content={category.content.filter(
          (item): item is NonNullable<typeof item> => item !== null,
        )}
        assetToken={assetToken}
        source="managers-category"
        showDescription={true}
      />
    </section>
  ) : null;
};
